import React from 'react'
import { Link } from 'react-router-dom'
import { Alert, Button, Row } from 'reactstrap'
import AutoTable from 'components/AutoTable'
import { IsRosteredBadge } from 'components/IsRosteredBadge/IsRosteredBadge'
import { NetSuiteAsset } from 'types'

import { SSLicenseIdColContainer } from './LicenseGrid.styles'

interface LicenseGridProps {
  licenses: NetSuiteAsset[]
  onEditLicense: (license: NetSuiteAsset) => void
}

const resolveSchoolName = (row: NetSuiteAsset): string => row.site?.name || ''

const LicenseGrid: React.FC<LicenseGridProps> = ({
  licenses,
  onEditLicense,
}) => {
  const columns = [
    {
      title: 'SS License ID',
      fieldValue: (row: NetSuiteAsset) => {
        return (
          <SSLicenseIdColContainer>
            <Link to={`/css-admin/licenses/${row.id}`}>{row.id}</Link>
            <IsRosteredBadge
              isRostered={row.site?.isRostered || false}
              summaryView={false}
            />
          </SSLicenseIdColContainer>
        )
      },
      sortValue: 'id',
    },
    {
      title: 'NS License ID',
      fieldValue: (row: NetSuiteAsset) => {
        return <span>{row.nsName}</span>
      },
      sortValue: 'nsName',
    },
    {
      title: 'Program Codes',
      fieldValue: (row: NetSuiteAsset) => {
        return row.product?.programCodes.join(', ') || '-'
      },
    },
    {
      title: 'School',
      fieldValue: (row: NetSuiteAsset) => {
        const schoolName = resolveSchoolName(row)
        return schoolName ? (
          <Link to={`/css-admin/sites/${row.site?.id}`}>{schoolName}</Link>
        ) : (
          '-'
        )
      },
      sortValue: resolveSchoolName,
    },
    {
      title: '',
      fieldValue: (license: NetSuiteAsset) => {
        return (
          <Button
            color="light"
            onClick={() => onEditLicense(license)}
            size="sm"
            style={{ float: 'right' }}
          >
            <i className="fas fa-pencil-alt text-info" />
            &nbsp;Edit
          </Button>
        )
      },
      sort: false,
      filter: false,
    },
  ]

  return licenses.length ? (
    <Row>
      <AutoTable
        borderless
        columns={columns}
        headThemeLight
        rows={licenses}
        sort
      />
    </Row>
  ) : (
    <Alert color="warning">No results found</Alert>
  )
}

export default LicenseGrid
